import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { gql, useLazyQuery } from "@apollo/client";
import InputBase from "@material-ui/core/InputBase";
import { fade } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useHistory } from "react-router-dom";

import { Search as SearchIcon } from "@material-ui/icons";

const styles = theme => ({
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto"
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit"
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "25ch",
      "&:focus": {
        width: "30ch"
      }
    }
  }
});

const GET_SEARCH_RESULTS = gql`
  query searchResultsQuery($searchString: String) {
    MainSearch(searchString: $searchString, first: 10) {
      id
      type
      name
    }
  }
`;

function SearchInput(props) {
  const { classes } = props;
  const [open, setOpen] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const history = useHistory();

  const [execute, { loading, data }] = useLazyQuery(GET_SEARCH_RESULTS, {
    variables: {
      searchString: searchTerm
    }
  });

  React.useEffect(() => {
    if (searchTerm && searchTerm.length >= 2) {
      execute();
    }
  }, [searchTerm, execute]);

  return (
    <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <Autocomplete
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        getOptionSelected={(option, value) => option.id === value.id}
        getOptionLabel={option => (option && option.name ? option.name : "")}
        options={data ? data.MainSearch : []}
        loading={loading}
        autoComplete
        freeSolo
        onInputChange={(_, newValue) => {
          setSearchTerm(newValue);
        }}
        onChange={(_, newValue) => {
          if (newValue && newValue.id)
            history.push(`/${newValue.type}/${newValue.id}`);
        }}
        noOptionsText="No results"
        renderInput={params => {
          return (
            <InputBase
              placeholder="Search for players, schools, etc."
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput
              }}
              ref={params.InputProps.ref}
              inputProps={{
                ...params.inputProps,
                "aria-label": "search"
              }}
            />
          );
        }}
      />
    </div>
  );
}

export default withStyles(styles)(SearchInput);
